module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inventory-block"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "inventory-block--titleinfo"
  }, [_vm._v("Resource type: Book ISBN: 93423-3432-4234-2 Paper.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "inventory-block--bottom"
  }, [_c('section', [_c('ui-icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inventory-block--top"
  }, [_c('section', {
    staticClass: "inventory-block--title"
  }, [_vm._v("BOOK NAME")]), _vm._v(" "), _c('section', {
    staticClass: "inventory-block--source"
  }, [_vm._v("Source: Gyldendal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inventory-block--tableblock"
  }, [_c('h4', {
    staticClass: "inventory-block--availability"
  }, [_vm._v("Physical availability")]), _vm._v(" "), _c('section', [_c('section', [_vm._v("TABLE HERE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("View more")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59794292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/InventoryBlock.vue
// module id = 449
// module chunks = 1